import { supabase } from "./supabaseClient";
import { useState, useEffect } from "react";

const SERVER = "https://legisim-server.onrender.com";

const CATEGORIES = ["State Agency","Executive","Legislature","Committee","Lobbyist","Association","Other"];

const EMPTY_ENTRY = { category:"State Agency", name:"", title:"", department:"", phone:"", email:"", website:"", address:"", notes:"", party:"" };

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=IBM+Plex+Sans:wght@300;400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;}
body{background:var(--bg);color:var(--text);font-family:var(--font-body);-webkit-font-smoothing:antialiased;}
.page{display:flex;flex-direction:column;height:100vh;overflow:hidden;background:var(--bg);}
.legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
.legisim-masthead::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent 0%,var(--gold) 30%,#e8c96a 50%,var(--gold) 70%,transparent 100%);}
.masthead-left{display:flex;align-items:center;gap:1rem;z-index:1;}
.masthead-right{display:flex;align-items:center;gap:0.6rem;z-index:1;}
.mast-back{background:transparent;border:2px solid var(--gold-dim);border-radius:8px;padding:0.45rem 1.1rem;color:var(--gold);font-family:var(--font-mono);font-size:0.72rem;font-weight:600;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;}
.mast-back:hover{border-color:var(--gold);background:var(--gold-glow);}
.mast-btn-sm{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.4rem 1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.7rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.18s;}
.mast-btn-sm:hover{border-color:var(--gold-dim);color:var(--gold);}
.masthead-wordmark{font-family:var(--font-display);font-size:1.35rem;font-weight:800;letter-spacing:-0.02em;color:var(--text);}
.masthead-wordmark em{font-style:italic;color:var(--gold);}
.masthead-wordmark sup{font-family:var(--font-mono);font-size:0.42rem;color:var(--muted);vertical-align:super;}
.da-body{flex:1;display:flex;overflow:hidden;}
.da-left{width:320px;flex-shrink:0;background:var(--surface);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;}
.da-right{flex:1;overflow-y:auto;scrollbar-width:thin;}
.da-section{padding:1.1rem 1.25rem;border-bottom:1px solid var(--border);}
.da-section-title{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:0.75rem;}
.da-label{font-family:var(--font-mono);font-size:0.62rem;color:var(--muted);letter-spacing:0.06em;margin-bottom:0.3rem;}
.da-input{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.5rem 0.75rem;color:var(--text);font-family:var(--font-mono);font-size:0.72rem;outline:none;transition:border-color 0.18s;margin-bottom:0.65rem;}
.da-input:focus{border-color:var(--gold-dim);}
.da-select{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.5rem 0.75rem;color:var(--text);font-family:var(--font-mono);font-size:0.72rem;cursor:pointer;margin-bottom:0.65rem;appearance:none;}
.da-textarea{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.5rem 0.75rem;color:var(--text);font-family:var(--font-mono);font-size:0.68rem;line-height:1.5;resize:vertical;min-height:80px;outline:none;}
.da-textarea:focus{border-color:var(--gold-dim);}
.da-btn{display:block;width:100%;padding:0.6rem 1rem;border-radius:8px;font-family:var(--font-mono);font-size:0.72rem;font-weight:600;cursor:pointer;transition:all 0.18s;letter-spacing:0.06em;text-align:center;border:none;margin-top:0.5rem;}
.da-btn.primary{background:var(--gold);color:#09090e;}
.da-btn.primary:hover{background:#e8c96a;}
.da-btn.secondary{background:transparent;border:1px solid var(--border);color:var(--muted);}
.da-btn.secondary:hover{border-color:var(--gold-dim);color:var(--gold);}
.da-btn.danger{background:transparent;border:1px solid rgba(192,57,43,0.4);color:#c0392b;margin-top:0.35rem;}
.da-btn.danger:hover{background:rgba(192,57,43,0.1);}
.da-status{font-family:var(--font-mono);font-size:0.65rem;padding:0.5rem 0.75rem;border-radius:6px;margin-top:0.5rem;}
.da-status.success{background:rgba(37,107,66,0.12);border:1px solid rgba(37,107,66,0.3);color:#2e8b57;}
.da-status.error{background:rgba(192,57,43,0.1);border:1px solid rgba(192,57,43,0.3);color:#c0392b;}
.da-view-toggle{display:flex;border-bottom:1px solid var(--border);}
.da-view-btn{flex:1;background:transparent;border:none;border-bottom:2px solid transparent;padding:0.55rem;font-family:var(--font-mono);font-size:0.6rem;letter-spacing:0.08em;text-transform:uppercase;color:var(--muted);cursor:pointer;margin-bottom:-1px;}
.da-view-btn.active{color:var(--gold);border-bottom-color:var(--gold);}
.da-entries{padding:1.25rem;}
.da-entries-title{font-family:var(--font-display);font-size:1.2rem;font-weight:800;color:var(--text);margin-bottom:1rem;}
.da-entry-item{display:flex;align-items:center;gap:0.75rem;padding:0.75rem 1rem;background:var(--surface);border:1px solid var(--border);border-radius:10px;margin-bottom:0.5rem;}
.da-entry-info{flex:1;min-width:0;}
.da-entry-name{font-size:0.85rem;font-weight:500;color:var(--text);margin-bottom:0.15rem;}
.da-entry-meta{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);}
.da-entry-actions{display:flex;gap:0.4rem;flex-shrink:0;}
.da-icon-btn{background:transparent;border:1px solid var(--border);border-radius:5px;padding:0.2rem 0.5rem;font-family:var(--font-mono);font-size:0.58rem;color:var(--muted);cursor:pointer;transition:all 0.18s;}
.da-icon-btn:hover{border-color:var(--gold-dim);color:var(--gold);}
.da-icon-btn.del:hover{border-color:rgba(192,57,43,0.4);color:#c0392b;}
.cat-pill{display:inline-block;padding:0.1rem 0.5rem;border-radius:100px;font-family:var(--font-mono);font-size:0.55rem;font-weight:600;}
.cat-pill.State.Agency,.cat-pill.State_Agency{background:rgba(59,111,212,0.1);color:#3b6fd4;border:1px solid rgba(59,111,212,0.2);}
.cat-pill.Executive{background:rgba(83,74,183,0.1);color:#534ab7;border:1px solid rgba(83,74,183,0.2);}
.cat-pill.Legislature{background:rgba(15,110,86,0.1);color:#0f6e56;border:1px solid rgba(15,110,86,0.2);}
.cat-pill.Committee{background:rgba(153,60,29,0.1);color:#993c1d;border:1px solid rgba(153,60,29,0.2);}
.cat-pill.Lobbyist,.cat-pill.Association{background:rgba(133,79,11,0.1);color:#854f0b;border:1px solid rgba(133,79,11,0.2);}
.cat-pill.Other{background:var(--surface2);color:var(--muted);border:1px solid var(--border);}
.da-search{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.5rem 0.75rem;color:var(--text);font-family:var(--font-mono);font-size:0.72rem;outline:none;margin-bottom:1rem;}
.da-cat-filter{display:flex;gap:0.4rem;flex-wrap:wrap;margin-bottom:1rem;}
.da-cat-chip{background:transparent;border:1px solid var(--border);border-radius:100px;padding:0.2rem 0.65rem;font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);cursor:pointer;}
.da-cat-chip.active{background:rgba(201,168,76,0.1);border-color:var(--gold-dim);color:var(--gold);}
.da-stats{display:flex;gap:0.75rem;flex-wrap:wrap;margin-bottom:1rem;}
.da-stat{background:var(--surface);border:1px solid var(--border);border-radius:8px;padding:0.5rem 0.9rem;text-align:center;}
.da-stat-num{font-family:var(--font-display);font-size:1.2rem;font-weight:800;color:var(--gold);}
.da-stat-label{font-family:var(--font-mono);font-size:0.55rem;color:var(--muted);letter-spacing:0.08em;text-transform:uppercase;}
[data-theme="light"] body{background:#eef1f7;color:#1a1e2e;}
[data-theme="light"] .page{background:#eef1f7;}
[data-theme="light"] .legisim-masthead{background:#1a2744;border-bottom-color:rgba(255,255,255,0.1);}
[data-theme="light"] .legisim-masthead::before{background:linear-gradient(90deg,transparent,var(--gold),transparent);}
[data-theme="light"] .masthead-wordmark{color:#e6e4dc;}
[data-theme="light"] .masthead-wordmark em{color:#c9a84c;}
[data-theme="light"] .mast-back{border-color:rgba(201,168,76,0.6);color:#c9a84c;}
[data-theme="light"] .mast-back:hover{background:rgba(201,168,76,0.12);border-color:#c9a84c;}
[data-theme="light"] .mast-btn-sm{color:#e6e4dc;border-color:rgba(201,168,76,0.4);}
[data-theme="light"] .da-left{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .da-input,.da-select,.da-textarea{background:#f0f2f8;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .da-entry-item{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .da-stat{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
`;

async function handleSignOut(supabaseClient, onNavigate) {
  await supabaseClient.auth.signOut();
  onNavigate("home");
}

function catPillClass(cat) {
  return "cat-pill " + (cat || "Other").replace(/ /g, "_");
}

export default function DirectoryAdmin({ onNavigate, profile }) {
  const [view, setView] = useState("add"); // "add" | "manage"
  const [entry, setEntry] = useState({ ...EMPTY_ENTRY });
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [catFilter, setCatFilter] = useState("All");
  const [adminKey, setAdminKey] = useState("");

  const isAdmin = profile?.role === "admin";

  useEffect(() => {
    fetch(`${SERVER}/api/directory`)
      .then(r => r.json())
      .then(d => { setEntries(d.entries || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [saving]);

  const update = (field, val) => setEntry(prev => ({ ...prev, [field]: val }));

  const handleSave = async () => {
    if (!entry.name.trim() || !adminKey) { setStatus({ type:"error", msg:"Name and admin key required." }); return; }
    setSaving(true);
    setStatus({ type:"info", msg:"Saving..." });
    try {
      const url = editingId
        ? `${SERVER}/api/directory/${editingId}`
        : `${SERVER}/api/directory`;
      const method = editingId ? "PATCH" : "POST";
      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: adminKey, entry })
      });
      const d = await r.json();
      if (d.error) throw new Error(d.error);
      setStatus({ type:"success", msg: editingId ? "Entry updated." : "Entry saved." });
      setEntry({ ...EMPTY_ENTRY });
      setEditingId(null);
    } catch (e) {
      setStatus({ type:"error", msg: e.message });
    }
    setSaving(false);
  };

  const handleEdit = (e) => {
    setEntry({ category:e.category||"Other", name:e.name||"", title:e.title||"", department:e.department||"", phone:e.phone||"", email:e.email||"", website:e.website||"", address:e.address||"", notes:e.notes||"", party:e.party||"" });
    setEditingId(e.id);
    setView("add");
    setStatus(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    try {
      const r = await fetch(`${SERVER}/api/directory/${id}?key=${adminKey}`, { method:"DELETE" });
      const d = await r.json();
      if (d.error) throw new Error(d.error);
      setEntries(prev => prev.filter(e => e.id !== id));
    } catch (e) {
      setStatus({ type:"error", msg:e.message });
    }
  };

  const filtered = entries.filter(e => {
    const q = search.toLowerCase();
    const matchSearch = !q || [e.name,e.title,e.department,e.category].some(f => (f||"").toLowerCase().includes(q));
    const matchCat = catFilter === "All" || e.category === catFilter;
    return matchSearch && matchCat;
  });

  if (!isAdmin) return (
    <>
      <style>{CSS}</style>
      <div className="page" style={{alignItems:"center",justifyContent:"center",display:"flex"}}>
        <div style={{fontFamily:"var(--font-mono)",fontSize:"0.8rem",color:"var(--muted)"}}>Admin access required.</div>
      </div>
    </>
  );

  return (
    <>
      <style>{CSS}</style>
      <div className="page">
        <div className="legisim-masthead">
          <div className="masthead-left">
            <div className="masthead-wordmark">Whip<em>Count</em><sup>TM</sup></div>
            <button className="mast-back" onClick={() => onNavigate("dashboard")}>← Dashboard</button>
          </div>
          <div className="masthead-right">
            <button className="mast-btn-sm" onClick={() => onNavigate("directory")}>View Directory</button>
            <button className="mast-btn-sm" onClick={() => onNavigate("account")}>Account</button>
            <button className="mast-btn-sm signout" onClick={() => handleSignOut(supabase, onNavigate)}>Sign Out</button>
          </div>
        </div>

        <div className="da-body">
          {/* LEFT PANEL */}
          <div className="da-left">
            <div className="da-view-toggle">
              <button className={`da-view-btn${view==="add"?" active":""}`} onClick={() => setView("add")}>
                {editingId ? "Edit Entry" : "Add Entry"}
              </button>
              <button className={`da-view-btn${view==="manage"?" active":""}`} onClick={() => setView("manage")}>
                Manage ({entries.length})
              </button>
            </div>

            <div className="da-section">
              <div className="da-section-title">Admin Key</div>
              <input className="da-input" type="password" placeholder="Enter admin secret" value={adminKey} onChange={e => setAdminKey(e.target.value)} />
            </div>

            {view === "add" && (
              <>
                <div className="da-section" style={{flex:1,overflowY:"auto"}}>
                  <div className="da-section-title">{editingId ? "Editing Entry" : "New Entry"}</div>

                  <div className="da-label">Category *</div>
                  <select className="da-select" value={entry.category} onChange={e => update("category", e.target.value)}>
                    {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>

                  <div className="da-label">Name *</div>
                  <input className="da-input" placeholder="Full name or organization name" value={entry.name} onChange={e => update("name", e.target.value)} />

                  <div className="da-label">Title / Role</div>
                  <input className="da-input" placeholder="e.g. Director, EGLE" value={entry.title} onChange={e => update("title", e.target.value)} />

                  <div className="da-label">Department / Agency</div>
                  <input className="da-input" placeholder="e.g. EGLE, MDOT" value={entry.department} onChange={e => update("department", e.target.value)} />

                  <div className="da-label">Party (if applicable)</div>
                  <select className="da-select" value={entry.party} onChange={e => update("party", e.target.value)}>
                    <option value="">—</option>
                    <option value="D">Democrat</option>
                    <option value="R">Republican</option>
                    <option value="I">Independent</option>
                  </select>

                  <div className="da-label">Phone</div>
                  <input className="da-input" placeholder="517-xxx-xxxx" value={entry.phone} onChange={e => update("phone", e.target.value)} />

                  <div className="da-label">Email</div>
                  <input className="da-input" type="email" placeholder="name@michigan.gov" value={entry.email} onChange={e => update("email", e.target.value)} />

                  <div className="da-label">Website</div>
                  <input className="da-input" placeholder="https://..." value={entry.website} onChange={e => update("website", e.target.value)} />

                  <div className="da-label">Address</div>
                  <input className="da-input" placeholder="Street, City, MI ZIP" value={entry.address} onChange={e => update("address", e.target.value)} />

                  <div className="da-label">Notes</div>
                  <textarea className="da-textarea" placeholder="Anything else relevant..." value={entry.notes} onChange={e => update("notes", e.target.value)} />

                  <button className="da-btn primary" onClick={handleSave} disabled={saving}>
                    {saving ? "Saving..." : editingId ? "Update Entry" : "Save to Directory"}
                  </button>
                  {editingId && (
                    <button className="da-btn secondary" onClick={() => { setEntry({...EMPTY_ENTRY}); setEditingId(null); setStatus(null); }}>
                      Cancel Edit
                    </button>
                  )}
                  {status && <div className={`da-status ${status.type}`}>{status.msg}</div>}
                </div>
              </>
            )}

            {view === "manage" && (
              <div className="da-section" style={{flex:1,overflowY:"auto"}}>
                <div className="da-section-title">Quick Stats</div>
                {["State Agency","Executive","Legislature","Committee","Lobbyist","Association"].map(cat => {
                  const n = entries.filter(e => e.category === cat).length;
                  return n > 0 ? <div key={cat} style={{fontFamily:"var(--font-mono)",fontSize:"0.65rem",color:"var(--muted)",marginBottom:"0.2rem"}}>{cat}: {n}</div> : null;
                })}
              </div>
            )}
          </div>

          {/* RIGHT PANEL */}
          <div className="da-right">
            <div className="da-entries">
              <div className="da-entries-title">Directory Entries</div>

              {/* Stats */}
              <div className="da-stats">
                {["All",...CATEGORIES].map(cat => {
                  const n = cat === "All" ? entries.length : entries.filter(e => e.category === cat).length;
                  if (n === 0 && cat !== "All") return null;
                  return (
                    <div className="da-stat" key={cat} style={{cursor:"pointer"}} onClick={() => setCatFilter(cat)}>
                      <div className="da-stat-num">{n}</div>
                      <div className="da-stat-label">{cat === "All" ? "Total" : cat}</div>
                    </div>
                  );
                })}
              </div>

              {/* Search + filter */}
              <input className="da-search" placeholder="Search by name, title, department..." value={search} onChange={e => setSearch(e.target.value)} />
              <div className="da-cat-filter">
                {["All",...CATEGORIES].map(cat => (
                  <button key={cat} className={`da-cat-chip${catFilter===cat?" active":""}`} onClick={() => setCatFilter(cat)}>{cat}</button>
                ))}
              </div>

              {/* Entries */}
              {loading ? (
                <div style={{fontFamily:"var(--font-mono)",fontSize:"0.7rem",color:"var(--muted)"}}>Loading...</div>
              ) : filtered.length === 0 ? (
                <div style={{fontFamily:"var(--font-mono)",fontSize:"0.7rem",color:"var(--muted)"}}>No entries yet. Add your first entry using the form on the left.</div>
              ) : filtered.map(e => (
                <div className="da-entry-item" key={e.id}>
                  <div className="da-entry-info">
                    <div className="da-entry-name">
                      {e.name}
                      <span className={catPillClass(e.category)} style={{marginLeft:"0.5rem"}}>{e.category}</span>
                    </div>
                    <div className="da-entry-meta">
                      {[e.title, e.department, e.phone].filter(Boolean).join(" · ")}
                    </div>
                  </div>
                  <div className="da-entry-actions">
                    <button className="da-icon-btn" onClick={() => handleEdit(e)}>Edit</button>
                    <button className="da-icon-btn del" onClick={() => handleDelete(e.id)}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
